"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ModelClient = void 0;
const api_1 = require("../core/api");
/**
 * Client that contains model related operations
 */
class ModelClient {
    constructor(config) {
        this.config = config;
        this.api = new api_1.ApiService(config);
    }
    /**
     * Fetch models by provided query
     * @param query @type Query
     */
    find(query) {
        const { api } = this;
        return api.get(["models"], query);
    }
    /**
     * Fetch single model by id or key
     * @param idOrKey @type string
     */
    single(idOrKey) {
        const { api } = this;
        return api.get(["models", idOrKey]);
    }
    /**
     * Create new model
     * @param body @type Model
     */
    create(body) {
        const { api } = this;
        return api.post(["models"], body);
    }
    /**
     * Update model
     * @param id @type string
     * @param body @type Model
     */
    update(id, body) {
        const { api } = this;
        return api.put(["models", id], body);
    }
    /**
     * Delete model
     * @param id @type string
     */
    destroy(id) {
        const { api } = this;
        return api.delete(["models", id]);
    }
}
exports.ModelClient = ModelClient;
//# sourceMappingURL=model.client.js.map